export const addHistoryEntry = (flowContext, _ref) => {
  let {
    targetPageId: pageId,
    targetFlowId: flowId,
    targetSnapshotId: snapshotId
  } = _ref;
  return {
    ...flowContext,
    historyEntries: [...flowContext.historyEntries, {
      pageId,
      flowId,
      snapshotId
    }]
  };
};
//# sourceMappingURL=addHistoryEntry.js.map